module.exports = __webpack_public_path__ + "img/sort_active.75bbb26a.svg";